import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';
import SvgColor from '../svg-color';
import Image from '../image';

// ----------------------------------------------------------------------

const Logo = forwardRef(
  ({ disabledLink = false, variant = 'dark', sx, ...other }, ref) => (
    <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '56px',
          ...sx,
        }}
      >
        <Image
          src={`/logo/logo-${variant}-large.svg`}
          alt="logo"
          sx={{
            width: '164px',
          }}
        />
      </Box>
    </Link>
  ),
);

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
  variant: PropTypes.oneOf(['light', 'darj']),
};

export default Logo;
